export const JWT_LOCAL_STORAGE_KEY = 'jwt';

export const IS_VENDOR = window.location.href.indexOf('vendor.') !== -1;

export const dateTimeFormat = 'YYYY-MM-DD HH:mm';

export const dateFormat = 'YYYY-MM-DD';



// WEBPACK FOOTER //
// ./src/consts/index.ts